import React, { useContext, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";

import { AuthContext } from "../../providers/AuthProvider";
import iconBack from "../../assets/icon-back.svg";
import iconCheck from "../../assets/icon-check.svg";
import iconNotCheck from "../../assets/Frame 21.png";
import iconHeart from "../../assets/Vector (23).png";

import "./CheckProfile.css";
import { AuthorizedLayout } from "../../components/AuthorizedLayout";
import {
  Button,
} from "@mui/material";
import { ArrowBackIos } from "@mui/icons-material";
import { FlexibleModal } from "./FlexibleModal";
import api from "../../utils/api";
import { toast } from "react-toastify";
import { getBase64 } from '../../utils/getBase64';

const parseBRLtoNumber = (value) => {
  if (typeof value === "number") return value;
  if (typeof value === "string") {
    const hasCurrency = value.includes("R$");
    const cleaned = value
      .replace(/\s/g, "")
      .replace("R$", "")
      .replace(hasCurrency ? /\./g : "", "")
      .replace(",", ".");
    const parsed = parseFloat(cleaned);
    return isNaN(parsed) ? null : parsed;
  }
  return null;
};

const CheckProfile = () => {
  const navigate = useNavigate();
  const { user, updateUser } = useContext(AuthContext);
  const [modalOpen, setModalOpen] = useState(false);
  const [activeField, setActiveField] = useState(null);
  const [fieldValue, setFieldValue] = useState("");
  const [avatarLoading, setAvatarLoading] = useState(false);

  const fileInputRef = useRef(null);

  const handleOpenFilePicker = () => {
    fileInputRef.current?.click();
  };

  const handleFileInputChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setAvatarLoading(true);
    getBase64(file, 800, 800)
      .then((result) => {
        file["base64"] = result;

        const updateSettings = async () => {
          try {
            const { data } = await api.put(`/talents/talents/${user.id}`, {
              data: {
                attributes: {
                  avatar: { data: result },
                },
              },
            });

            if (data) {
              updateUser(data);
              toast.success("Foto do perfil atualizada com sucesso!");
            }
          } catch (error) {
            toast.error("Ocorreu um erro ao tentar atualizar os dados da conta.");
          } finally {
            setAvatarLoading(false);
          }
        };

        updateSettings();
      })
      .catch((error) => {
        if (error?.response?.status) {
          if (error.response.status !== 401) {
            if (
              error?.response?.data?.errors &&
              error?.response?.data?.errors[0]?.title
            ) {
              alert(`${error.response.data.errors[0].title}`);
            } else {
              alert("Algo inesperado aconteceu. Tente novamente.");
            }
          } else {
            alert("Sessão expirada. Faça login novamente.");
          }
        } else {
          alert("Algo inesperado aconteceu. Tente novamente.");
        }
        setAvatarLoading(false);
      });
  };

  const checkList = {
    userAVatar: !!user?.avatar,
    isSalaryFilled: user?.salary && user.salary > 0,
    isBirthDateFilled: !!user?.birthdate,
    isContractTypeFilled: !!user?.contractType,
    isWorkModelFilled: !!user?.workModel,
    isSeniorityLevelFilled: !!user?.seniorityLevel,
    isLinkedinFilled: !!user?.linkedinUrl,
    isCulturalFitFilled: user?.isCulturalFitFilled,
    isSelfieLetterFilled: user?.isSelfieLetterFilled,
    isTalentKnowledgeAreaFilled: user?.isTalentKnowledgeAreaFilled,
    isTalentKnowledgeSkillFilled: user?.isTalentKnowledgeSkillFilled,
    isBioFilled: !!user?.bio,
  };

  const handleSaveField = async () => {
    try {
      let payloadData = {};
      if (activeField === "salary" && typeof fieldValue === "object") {
        payloadData = {
          salary: parseBRLtoNumber(fieldValue.salary),
          salaryNegotiable:
            fieldValue.salaryNegotiable !== undefined
              ? fieldValue.salaryNegotiable
              : null,
        };
      } else {
        payloadData = {
          [activeField]:
            activeField === "salary"
              ? parseBRLtoNumber(fieldValue)
              : activeField === "contractType"
                ? fieldValue !== "" ? parseInt(fieldValue, 10) : null
                : activeField === "workModel"
                  ? Array.isArray(fieldValue) ? fieldValue : []
                  : activeField === "bio"
                    ? fieldValue !== "" ? fieldValue : null
                    : fieldValue,
        };
      }

      const payload = {
        data: {
          attributes: payloadData,
        },
      };

      const { data } = await api.put(`/talents/talents/${user.id}`, payload);
      if (data) {
        toast.success("Informação atualizada com sucesso!");
        updateUser(data);
        setModalOpen(false);
      }
    } catch (err) {
      toast.error("Erro ao salvar informação");
    }
  };

  return (
    <>
      <AuthorizedLayout>
        <div className="containerCheckProfile">
          <div className="checkProfileMainWrapper">
            <div className="checkProfileContent">

              <div className="checkProfileContentWrapper">
                <Button
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    gap: "5px",
                    padding: "0"
                  }}
                  color="secondary"
                  style={{ textTransform: "none" }}
                  onClick={() => navigate("/settings")}
                >
                  <img
                    src={iconBack}
                    alt="icon-back"
                  />
                  <div className="textProfile">Perfil</div>
                </Button>
              </div>
              <div className="contentContainer2">
                <div
                  className="cardCheck"
                  style={{
                    backgroundColor: user?.avatar && "#D8F6F5",
                    border: user?.avatar && "1px solid #0AC6BD",
                    position: "relative",
                  }}
                  onClick={handleOpenFilePicker}
                >
                  {!user?.avatar && <div className="iconNotific"></div>}

                  <img
                    src={user?.avatar ? iconCheck : iconNotCheck}
                    style={{ width: "20px", height: "20px" }}
                    alt="icon"
                  />
                  <div
                    className="textCard"
                    style={{
                      color: user?.avatar && "#2D2D2D",
                    }}
                  >
                    Adicionar foto
                  </div>
                </div>

                <div
                  className="cardCheck"
                  style={{
                    backgroundColor:
                      checkList["isBirthDateFilled"] && "#D8F6F5",
                    border:
                      checkList["isBirthDateFilled"] && "1px solid #0AC6BD",
                    position: "relative",
                  }}
                  onClick={() => {
                    setActiveField("birthdate");
                    setFieldValue(user?.birthdate || "");
                    setModalOpen(true);
                  }}
                >
                  {!checkList["isBirthDateFilled"] && (
                    <div className="iconNotific"></div>
                  )}

                  <img
                    src={
                      checkList["isBirthDateFilled"] ? iconCheck : iconNotCheck
                    }
                    style={{ width: "20px", height: "20px" }}
                    alt="icon"
                  />
                  <div
                    className="textCard"
                    style={{
                      color: checkList["isBirthDateFilled"] && "#2D2D2D",
                    }}
                  >
                    Data de nascimento
                  </div>
                </div>

                <div
                  className="cardCheck"
                  style={{
                    backgroundColor:
                      checkList["isSalaryFilled"] && "#D8F6F5",
                    border:
                      checkList["isSalaryFilled"] && "1px solid #0AC6BD",
                    position: "relative",
                  }}
                  onClick={() => {
                    setActiveField("salary");
                    setFieldValue({
                      salary: user?.salary
                        ? user.salary.toLocaleString("pt-BR", {
                          style: "currency",
                          currency: "BRL",
                        })
                        : "",
                      salaryNegotiable: user?.salaryNegotiable !== undefined ? user.salaryNegotiable : null,
                    });
                    setModalOpen(true);
                  }}
                >
                  {!checkList["isSalaryFilled"] && (
                    <div className="iconNotific"></div>
                  )}

                  <img
                    src={
                      checkList["isSalaryFilled"] ? iconCheck : iconNotCheck
                    }
                    style={{ width: "20px", height: "20px" }}
                    alt="icon"
                  />
                  <div
                    className="textCard"
                    style={{
                      color: checkList["isSalaryFilled"] && "#2D2D2D",
                    }}
                  >
                    Pretensão Salarial
                  </div>
                </div>

                <div
                  className="cardCheck"
                  style={{
                    backgroundColor:
                      checkList["isContractTypeFilled"] && "#D8F6F5",
                    border:
                      checkList["isContractTypeFilled"] && "1px solid #0AC6BD",
                    position: "relative",
                  }}
                  onClick={() => {
                    setActiveField("contractType");
                    setFieldValue(user?.contractType !== null ? (
                      user?.contractType === "clt" ? 0 :
                        user?.contractType === "pj" ? 1 :
                          user?.contractType === "both" ? 2 :
                            ""
                    ) : "");
                    setModalOpen(true);
                  }}
                >
                  {!checkList["isContractTypeFilled"] && (
                    <div className="iconNotific"></div>
                  )}

                  <img
                    src={
                      checkList["isContractTypeFilled"] ? iconCheck : iconNotCheck
                    }
                    style={{ width: "20px", height: "20px" }}
                    alt="icon"
                  />
                  <div
                    className="textCard"
                    style={{
                      color: checkList["isContractTypeFilled"] && "#2D2D2D",
                    }}
                  >
                    Regime de Contratação
                  </div>
                </div>

                <div
                  className="cardCheck"
                  style={{
                    backgroundColor:
                      checkList["isWorkModelFilled"] && "#D8F6F5",
                    border:
                      checkList["isWorkModelFilled"] && "1px solid #0AC6BD",
                    position: "relative",
                  }}
                  onClick={() => {
                    setActiveField("workModel");
                    setFieldValue(Array.isArray(user?.workModel) ? user.workModel : []);
                    setModalOpen(true);
                  }}
                >
                  {!checkList["isWorkModelFilled"] && (
                    <div className="iconNotific"></div>
                  )}

                  <img
                    src={
                      checkList["isWorkModelFilled"] ? iconCheck : iconNotCheck
                    }
                    style={{ width: "20px", height: "20px" }}
                    alt="icon"
                  />
                  <div
                    className="textCard"
                    style={{
                      color: checkList["isWorkModelFilled"] && "#2D2D2D",
                    }}
                  >
                    Modelo de Trabalho
                  </div>
                </div>

                <div
                  className="cardCheck"
                  style={{
                    backgroundColor:
                      checkList["isBioFilled"] && "#D8F6F5",
                    border:
                      checkList["isBioFilled"] && "1px solid #0AC6BD",
                    position: "relative",
                  }}
                  onClick={() => {
                    setActiveField("bio");
                    setFieldValue(user.bio || "");
                    setModalOpen(true);
                  }}
                >
                  {!checkList["isBioFilled"] && (
                    <div className="iconNotific"></div>
                  )}

                  <img
                    src={
                      checkList["isBioFilled"] ? iconCheck : iconNotCheck
                    }
                    style={{ width: "20px", height: "20px" }}
                    alt="icon"
                  />
                  <div
                    className="textCard"
                    style={{
                      color: checkList["isBioFilled"] && "#2D2D2D",
                    }}
                  >
                    Escreva uma breve apresentação sua
                  </div>
                </div>

                <div
                  className="cardCheck"
                  style={{
                    backgroundColor:
                      checkList["isSeniorityLevelFilled"] && "#D8F6F5",
                    border:
                      checkList["isSeniorityLevelFilled"] && "1px solid #0AC6BD",
                    position: "relative",
                  }}
                  onClick={() => {
                    setActiveField("seniorityLevel");
                    setFieldValue(user?.seniorityLevel !== null ? (
                      user?.seniorityLevel === "assistant" ? 0 :
                        user?.seniorityLevel === "associate" ? 1 :
                          user?.seniorityLevel === "junior_analyst" ? 2 :
                            user?.seniorityLevel === "analyst" ? 3 :
                              user?.seniorityLevel === "senior_analyst" ? 4 :
                                user?.seniorityLevel === "coordinator" ? 5 :
                                  user?.seniorityLevel === "manager" ? 6 :
                                    user?.seniorityLevel === "director" ? 7 :
                                      user?.seniorityLevel === "c_level" ? 8 :
                                        ""
                    ) : "");
                    setModalOpen(true);
                  }}
                >
                  {!checkList["isSeniorityLevelFilled"] && (
                    <div className="iconNotific"></div>
                  )}

                  <img
                    src={
                      checkList["isSeniorityLevelFilled"] ? iconCheck : iconNotCheck
                    }
                    style={{ width: "20px", height: "20px" }}
                    alt="icon"
                  />
                  <div
                    className="textCard"
                    style={{
                      color: checkList["isSeniorityLevelFilled"] && "#2D2D2D",
                    }}
                  >
                    Nível de Senioridade
                  </div>
                </div>

                <div
                  className="cardCheck"
                  style={{
                    backgroundColor:
                      checkList["isLinkedinFilled"] && "#D8F6F5",
                    border:
                      checkList["isLinkedinFilled"] && "1px solid #0AC6BD",
                    position: "relative",
                  }}
                  onClick={() => {
                    setActiveField("linkedinUrl");
                    setFieldValue(user?.linkedinUrl || "");
                    setModalOpen(true);
                  }}
                >
                  {!checkList["isLinkedinFilled"] && (
                    <div className="iconNotific"></div>
                  )}

                  <img
                    src={
                      checkList["isLinkedinFilled"] ? iconCheck : iconNotCheck
                    }
                    style={{ width: "20px", height: "20px" }}
                    alt="icon"
                  />
                  <div
                    className="textCard"
                    style={{
                      color: checkList["isLinkedinFilled"] && "#2D2D2D",
                    }}
                  >
                    LinkedIn
                  </div>
                </div>

                <div
                  className="cardCheck"
                  style={{
                    backgroundColor:
                      checkList["isTalentKnowledgeAreaFilled"] && "#D8F6F5",
                    border:
                      checkList["isTalentKnowledgeAreaFilled"] &&
                      "1px solid #0AC6BD",
                    position: "relative",
                  }}
                  onClick={() => navigate("/skills")}
                >
                  {!checkList["isTalentKnowledgeAreaFilled"] && (
                    <div className="iconNotific"></div>
                  )}
                  <img
                    src={
                      checkList["isTalentKnowledgeAreaFilled"]
                        ? iconCheck
                        : iconNotCheck
                    }
                    style={{ width: "20px", height: "20px" }}
                    alt="icon"
                  />
                  <div
                    className="textCard"
                    style={{
                      color:
                        checkList["isTalentKnowledgeAreaFilled"] && "#2D2D2D",
                    }}
                  >
                    Habilidades
                  </div>
                </div>

                <div
                  className="cardCheck"
                  style={{
                    backgroundColor:
                      checkList["isTalentKnowledgeSkillFilled"] && "#D8F6F5",
                    border:
                      checkList["isTalentKnowledgeSkillFilled"] &&
                      "1px solid #0AC6BD",
                    position: "relative",
                  }}
                  onClick={() => navigate("/knowledge")}
                >
                  {!checkList["isTalentKnowledgeSkillFilled"] && (
                    <div className="iconNotific"></div>
                  )}
                  <img
                    src={
                      checkList["isTalentKnowledgeSkillFilled"]
                        ? iconCheck
                        : iconNotCheck
                    }
                    style={{ width: "20px", height: "20px" }}
                    alt="icon"
                  />
                  <div
                    className="textCard"
                    style={{
                      color:
                        checkList["isTalentKnowledgeSkillFilled"] && "#2D2D2D",
                    }}
                  >
                    Conhecimentos
                  </div>
                </div>

                <div
                  className="cardCheck"
                  style={{
                    backgroundColor:
                      checkList["isCulturalFitFilled"] && "#D8F6F5",
                    border:
                      checkList["isCulturalFitFilled"] && "1px solid #0AC6BD",
                    position: "relative",
                  }}
                  onClick={() => navigate("/fit-cultural")}
                >
                  {!checkList["isCulturalFitFilled"] && (
                    <div className="iconNotific"></div>
                  )}
                  <img
                    src={
                      checkList["isCulturalFitFilled"] ? iconCheck : iconNotCheck
                    }
                    style={{ width: "20px", height: "20px" }}
                    alt="icon"
                  />
                  <div
                    className="textCard"
                    style={{
                      color: checkList["isCulturalFitFilled"] && "#2D2D2D",
                    }}
                  >
                    Fit Cultural
                  </div>
                </div>

                <div
                  className="cardCheck"
                  style={{
                    backgroundColor:
                      checkList["isSelfieLetterFilled"] && "#D8F6F5",
                    border:
                      checkList["isSelfieLetterFilled"] && "1px solid #0AC6BD",
                    position: "relative",
                  }}
                  onClick={() => navigate("/selfie-letter")}
                >
                  {!checkList["isSelfieLetterFilled"] && (
                    <div className="iconNotific"></div>
                  )}

                  <img
                    src={
                      checkList["isSelfieLetterFilled"] ? iconCheck : iconNotCheck
                    }
                    style={{ width: "20px", height: "20px" }}
                    alt="icon"
                  />
                  <div
                    className="textCard"
                    style={{
                      color: checkList["isSelfieLetterFilled"] && "#2D2D2D",
                    }}
                  >
                    Selfie Letter
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
        <div className="footerMobileFixed">
          Desenvolvido com
          <img src={iconHeart} alt="" />
          <strong>© eComLovers®</strong>
        </div>

        <FlexibleModal
          open={modalOpen}
          onClose={() => setModalOpen(false)}
          title="Editar informação"
          fieldKey={activeField}
          fieldValue={fieldValue}
          setFieldValue={setFieldValue}
          onSave={handleSaveField}
          placeholder="Informe o valor"
          user={user}
        />

        <input
          type="file"
          id="fupload"
          name="fupload"
          className="fupload form-control"
          accept=".jpeg, .png, .jpg"
          onChange={handleFileInputChange}
          ref={fileInputRef}
          style={{ display: "none" }}
        />
      </AuthorizedLayout>

      {avatarLoading && (
        <div className="globalSpinnerOverlay">
          <div className="spinner" />
        </div>
      )}
    </>
  );
};

export default CheckProfile;
